import {
  trackBulkActionsMoveTabClicked,
  trackBulkActionsEmailTabClicked,
} from '../../../../../utils/events';
import { MODAL_NAME } from '../../../../../constants/modals';
import type { TrackBulkActionsItemLinkClickedAttributes } from '../../../../../utils/eventsTypes';
import { useTranslations } from '@vocab/react';
import translations from '../.vocab';

export enum BULK_ACTION {
  EMAIL,
  MOVE,
}

interface BulkActionAttributes {
  name: string;
  modalName: MODAL_NAME;
  itemLinkLabel: string;
  tooltipText: string;
  trackOnClick: (attributes: TrackBulkActionsItemLinkClickedAttributes) => void;
}

export const useGetBulkActionItemAttributes = (
  bulkAction: BULK_ACTION,
): BulkActionAttributes => {
  const { t } = useTranslations(translations);
  switch (bulkAction) {
    case BULK_ACTION.MOVE:
      return {
        name: 'move',
        modalName: MODAL_NAME.BULK_ACTIONS_UPDATE_STATUS,
        itemLinkLabel: t('Move'),
        tooltipText: t('Please select applications to move'),
        trackOnClick: trackBulkActionsMoveTabClicked,
      };
    case BULK_ACTION.EMAIL:
      return {
        name: 'email',
        modalName: MODAL_NAME.BULK_ACTIONS_EMAIL,
        itemLinkLabel: t('Email'),
        tooltipText: t('Please select candidates to email'),
        trackOnClick: trackBulkActionsEmailTabClicked,
      };
    default:
      throw new Error('unknown bulk action error');
  }
};
